import React from 'react';
import Layout from './Layout';
import { Career } from '../../components/User/Career'

export const CareerPage = () => <Layout><Career></Career></Layout>
